import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "../utils/util.js";
import { getUserInfo } from "../utils/auth.js";
import { Message } from "element-ui";
Vue.use(VueRouter);

// 路由守卫：检查个人中心访问权限
const checkUserCenterAccess = (to, from, next, allowedIdentities) => {
  const token = getToken();
  const userInfo = getUserInfo();

  // // 检查是否已登录
  // if (!token || !userInfo) {
  //   Message.warning("请先登录");
  //   next({
  //     path: "/login",
  //     query: { redirect: to.fullPath }, // 保存原始路径，登录后可以跳转回来
  //   });
  //   return;
  // }

  // // 检查用户身份是否匹配
  // if (userInfo.identity === undefined || userInfo.identity === null) {
  //   Message.warning("用户身份信息不完整，请重新登录");
  //   next({
  //     path: "/login",
  //   });
  //   return;
  // }

  // // 检查身份是否在允许的列表中
  // if (!allowedIdentities.includes(userInfo.identity)) {
  //   Message.warning("您没有权限访问该页面");
  //   // 根据用户身份跳转到对应的个人中心首页
  //   const identityMap = {
  //     0: "/companyUserCen/postManager", // 企业管理员
  //     1: "/HrUserCen/postManager", // 企业HR
  //     2: "/SchoolUserCen/dataStatistics", // 院校管理员
  //     3: "/TeacherUserCen/studentManager", // 院校教师
  //     4: "/StudentCen/index", // 学生
  //   };
  //   const defaultPath = identityMap[userInfo.identity] || "/";
  //   next(defaultPath);
  //   return;
  // }

  // 通过验证，允许访问
  next();
};
const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },

  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/xieiyi",
    name: "Xieiyi",
    component: () => import("../views/Xieiyi.vue"),
  },
  // 学生端路由
  {
    path: "/student/registerSteps",
    name: "StudentRegisterSteps",
    component: () => import("../views/Student/RegisterSteps.vue"),
  },
  // 院校端路由
  {
    path: "/school/registerSteps",
    name: "SchoolRegisterSteps",
    component: () => import("../views/School/RegisterSteps.vue"),
  },
  {
    path: "/school/formSteps",
    name: "SchoolFormSteps",
    component: () => import("../views/School/FormSteps.vue"),
  },
  // 企业端
  {
    path: "/company/registerSteps",
    name: "CompanyRegisterSteps",
    component: () => import("../views/Company/RegisterSteps.vue"),
  },
  {
    path: "/company/formSteps",
    name: "CompanyFormSteps",
    component: () => import("../views/Company/FormSteps.vue"),
  },
  // 首页
  {
    path: "/",
    name: "Index",
    component: () => import("../views/Index.vue"),
  },
  {
    path: "/positions",
    name: "Positions",
    component: () => import("../views/Positions.vue"),
  },
  {
    path: "/companies",
    name: "Companies",
    component: () => import("../views/Companies.vue"),
  },
  {
    path: "/schools",
    name: "Schools",
    component: () => import("../views/Schools.vue"),
  },
  {
    path: "/positionDetail",
    name: "PositionDetail",
    component: () => import("../views/PositionDetail.vue"),
  },
  {
    path: "/companyDetail",
    name: "CompanyDetail",
    component: () => import("../views/CompanyDetail.vue"),
  },
  {
    path: "/schoolDetail",
    name: "SchoolDetail",
    component: () => import("../views/SchoolDetail.vue"),
  },
  {
    path: "/findAccount",
    name: "FindAccount",
    component: () => import("../views/FindAccount.vue"),
  },
  {
    path: "/chat",
    name: "Chat",
    component: () => import("../views/Chat.vue"),
  },
  {
    path: "/message",
    name: "Message",
    component: () => import("../views/Message.vue"),
  },
  // { path: '/chat', component: IM },
  // 企业个人中心 (identity: 0)
  {
    path: "/companyUserCen",
    redirect: "/companyUserCen/postManager",
  },
  {
    path: "/companyUserCen/postManager",
    name: "CompanyUserCenPostManager",
    component: () => import("../views/CompanyUserCen/PostManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/talentRecommend",
    name: "CompanyUserCenTalentRecommend",
    component: () => import("../views/CompanyUserCen/TalentRecommend.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/addPostManager",
    name: "CompanyUserCenAddPostManager",
    component: () => import("../views/CompanyUserCen/addPostManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/aiCampus/candidateList",
    name: "CompanyUserCenAiCampusCandidateList",
    component: () =>
      import("../views/CompanyUserCen/AiCampus/CandidateList.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/aiCampus/candidateReport",
    name: "CompanyUserCenAiCampusCandidateReport",
    component: () =>
      import("../views/CompanyUserCen/AiCampus/CandidateReport.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/aiCampus/appointmentManage",
    name: "CompanyUserCenAiCampusAppointmentManage",
    component: () =>
      import("../views/CompanyUserCen/AiCampus/AppointmentManage.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },

  {
    path: "/companyUserCen/resume",
    name: "CompanyUserCenResume",
    component: () => import("../views/CompanyUserCen/Resume.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/talentSearch",
    name: "CompanyUserCenTalentSearch",
    component: () => import("../views/CompanyUserCen/TalentSearch.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/offerManager",
    name: "CompanyUserCenOfferManager",
    component: () => import("../views/CompanyUserCen/OfferManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/memberManager",
    name: "CompanyUserCenMemberManager",
    component: () => import("../views/CompanyUserCen/MemberManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/companyInfo",
    name: "CompanyUserCenCompanyInfo",
    component: () => import("../views/CompanyUserCen/CompanyInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/editCompanyInfo",
    name: "CompanyUserCenEditCompanyInfo",
    component: () => import("../views/CompanyUserCen/editCompanyInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/personalInfo",
    name: "CompanyUserCenPersonalInfo",
    component: () => import("../views/CompanyUserCen/PersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/editPersonalInfo",
    name: "CompanyUserCenEditPersonalInfo",
    component: () => import("../views/CompanyUserCen/editPersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/privacy",
    name: "CompanyUserCenPrivacy",
    component: () => import("../views/CompanyUserCen/Privacy.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  {
    path: "/companyUserCen/chat",
    name: "CompanyUserCenChat",
    component: () => import("../views/CompanyUserCen/Chat.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [0]),
  },
  // 人力资源个人中心 (identity: 1)
  {
    path: "/HrUserCen",
    redirect: "/HrUserCen/postManager",
  },
  {
    path: "/HrUserCen/postManager",
    name: "HrUserCenPostManager",
    component: () => import("../views/CompanyUserCen/PostManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/addPostManager",
    name: "HrUserCenAddPostManager",
    component: () => import("../views/CompanyUserCen/addPostManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/aiCampus/candidateList",
    name: "HrUserCenAiCampusCandidateList",
    component: () =>
      import("../views/CompanyUserCen/AiCampus/CandidateList.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/aiCampus/candidateReport",
    name: "HrUserCenAiCampusCandidateReport",
    component: () =>
      import("../views/CompanyUserCen/AiCampus/CandidateReport.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/aiCampus/appointmentManage",
    name: "HrUserCenAiCampusAppointmentManage",
    component: () =>
      import("../views/CompanyUserCen/AiCampus/AppointmentManage.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/talentRecommend",
    name: "HrUserCenTalentRecommend",
    component: () => import("../views/HrUserCen/TalentRecommend.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/talentSearch",
    name: "HrUserCenTalentSearch",
    component: () => import("../views/HrUserCen/TalentSearch.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/resume",
    name: "HrUserCenResume",
    component: () => import("../views/HrUserCen/Resume.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/offerManager",
    name: "HrUserCenOfferManager",
    component: () => import("../views/HrUserCen/OfferManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/personalInfo",
    name: "HrUserCenPersonalInfo",
    component: () => import("../views/HrUserCen/PersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/editPersonalInfo",
    name: "HrUserCenEditPersonalInfo",
    component: () => import("../views/HrUserCen/editPersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/privacy",
    name: "HrUserCenPrivacy",
    component: () => import("../views/HrUserCen/Privacy.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/chat",
    name: "HrUserCenChat",
    component: () => import("../views/HrUserCen/Chat.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },
  {
    path: "/HrUserCen/companyInfo",
    name: "HrUserCenCompanyInfo",
    component: () => import("../views/HrUserCen/CompanyInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [1]),
  },

  // 教师个人中心 (identity: 3)
  {
    path: "/TeacherUserCen",
    redirect: "/TeacherUserCen/studentManager",
  },
  {
    path: "/TeacherUserCen/studentManager",
    name: "TeacherUserCenStudentManager",
    component: () => import("../views/TeacherUserCen/StudentManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/defenseCoaching",
    name: "TeacherUserCenDefenseCoaching",
    component: () =>
      import("../views/TeacherUserCen/DefenseCoaching/CoachingWorkbench.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/defenseCoaching/:studentId",
    name: "TeacherUserCenDefenseCoachingDetail",
    component: () =>
      import("../views/TeacherUserCen/DefenseCoaching/CoachingDetail.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/defenseCoaching/:studentId/report/:reportId",
    name: "TeacherUserCenDefenseReportDetail",
    component: () =>
      import("../views/TeacherUserCen/DefenseCoaching/DefenseReportDetail.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/chat",
    name: "TeacherUserCenChat",
    component: () => import("../views/TeacherUserCen/Chat.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/personalInfo",
    name: "TeacherUserCenPersonalInfo",
    component: () => import("../views/TeacherUserCen/PersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/privacy",
    name: "TeacherUserCenPrivacy",
    component: () => import("../views/TeacherUserCen/Privacy.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/editPersonalInfo",
    name: "TeacherUserCenEditPersonalInfo",
    component: () => import("../views/TeacherUserCen/editPersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  {
    path: "/TeacherUserCen/resume",
    name: "TeacherUserCenResume",
    component: () => import("../views/TeacherUserCen/Resume.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [3]),
  },
  // 院校个人中心 (identity: 2)
  {
    path: "/SchoolUserCen",
    redirect: "/SchoolUserCen/dataStatistics",
  },
  {
    path: "/SchoolUserCen/dataStatistics",
    name: "SchoolUserCenDataStatistics",
    component: () => import("../views/SchoolUserCen/DataStatistics.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/studentManager",
    name: "SchoolUserCenStudentManager",
    component: () => import("../views/SchoolUserCen/StudentManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/professionalManagement",
    name: "SchoolUserCenProfessionalManagement",
    component: () =>
      import("../views/SchoolUserCen/professionalManagement.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/addProfessionalManagement",
    name: "SchoolUserCenAddProfessionalManagement",
    component: () =>
      import("../views/SchoolUserCen/addProfessionalManagement.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/chat",
    name: "SchoolUserCenChat",
    component: () => import("../views/SchoolUserCen/Chat.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/personalInfo",
    name: "SchoolUserCenPersonalInfo",
    component: () => import("../views/SchoolUserCen/PersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/privacy",
    name: "SchoolUserCenPrivacy",
    component: () => import("../views/SchoolUserCen/Privacy.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/editPersonalInfo",
    name: "SchoolUserCenEditPersonalInfo",
    component: () => import("../views/SchoolUserCen/editPersonalInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/resume",
    name: "SchoolUserCenResume",
    component: () => import("../views/SchoolUserCen/Resume.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/teacherManager",
    name: "SchoolUserCenTeacherManager",
    component: () => import("../views/SchoolUserCen/TeacherManager.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/teacherInfo",
    name: "SchoolUserCenTeacherInfo",
    component: () => import("../views/SchoolUserCen/TeacherInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/schoolInfo",
    name: "SchoolUserCenSchoolInfo",
    component: () => import("../views/SchoolUserCen/SchoolInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/editSchoolInfo",
    name: "SchoolUserCenEditSchoolInfo",
    component: () => import("../views/SchoolUserCen/EditSchoolInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/departmental",
    name: "SchoolUserCenDepartmental",
    component: () => import("../views/SchoolUserCen/Departmental.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/class",
    name: "SchoolUserCenClass",
    component: () => import("../views/SchoolUserCen/Class.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  // AI 模拟面试相关路由
  {
    path: "/SchoolUserCen/AIInterview/dashboard",
    name: "SchoolUserCenAIInterviewDashboard",
    component: () => import("../views/SchoolUserCen/AIInterview/Dashboard.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/AIInterview/dataStatistics",
    name: "SchoolUserCenAIInterviewDataStatistics",
    component: () => import("../views/SchoolUserCen/AIInterview/DataStatistics.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/AIInterview/interviewRecords",
    name: "SchoolUserCenAIInterviewInterviewRecords",
    component: () => import("../views/SchoolUserCen/AIInterview/InterviewRecords.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/AIInterview/positionManagement",
    name: "SchoolUserCenAIInterviewPositionManagement",
    component: () => import("../views/SchoolUserCen/AIInterview/PositionManagement.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  // 职规赛模拟（院校管理员）
  {
    path: "/SchoolUserCen/defenseSim",
    redirect: "/SchoolUserCen/defenseSim/records",
  },
  {
    path: "/SchoolUserCen/defenseSim/records",
    name: "SchoolUserCenDefenseSimRecords",
    component: () =>
      import("../views/SchoolUserCen/DefenseSim/DefenseRecords.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/defenseSim/stats",
    name: "SchoolUserCenDefenseSimStats",
    component: () =>
      import("../views/SchoolUserCen/DefenseSim/DefenseStats.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/defenseSim/seasons",
    name: "SchoolUserCenDefenseSimSeasons",
    component: () =>
      import("../views/SchoolUserCen/DefenseSim/SeasonManage.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/defenseSim/report/:id",
    name: "SchoolUserCenDefenseSimReport",
    component: () =>
      import("../views/SchoolUserCen/DefenseSim/DefenseReportDetail.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  {
    path: "/SchoolUserCen/careerPlanning",
    name: "SchoolUserCenCareerPlanning",
    component: () => import("../views/SchoolUserCen/CareerPlanning/Index.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [2]),
  },
  // 学生个人中心 (identity: 4)
  {
    path: "/StudentCen",
    redirect: "/StudentCen/index",
  },
  {
    path: "/StudentCen/index",
    name: "StudentCenIndex",
    component: () => import("../views/StudentCen/Index.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/addResume",
    name: "StudentCenAddResume",
    component: () => import("../views/StudentCen/AddResume.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/resume",
    name: "StudentCenResume",
    component: () => import("../views/StudentCen/Resume.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/editInfo",
    name: "StudentCenEditInfo",
    component: () => import("../views/StudentCen/EditInfo.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/growth",
    name: "StudentCenGrowth",
    component: () => import("../views/StudentCen/Growth.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/defensePrep",
    redirect: "/StudentCen/defensePrep/growthMaterials",
  },
  {
    path: "/StudentCen/defensePrep/growthMaterials",
    name: "StudentCenDefensePrepGrowthMaterials",
    component: () =>
      import("../views/StudentCen/DefensePrep/GrowthMaterials.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/defensePrep/employmentMaterials",
    name: "StudentCenDefensePrepEmploymentMaterials",
    component: () =>
      import("../views/StudentCen/DefensePrep/EmploymentMaterials.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/defensePrep/records",
    name: "StudentCenDefensePrepRecords",
    component: () =>
      import("../views/StudentCen/DefensePrep/DefenseRecords.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/defensePrep/report/:id",
    name: "StudentCenDefensePrepReport",
    component: () =>
      import("../views/StudentCen/DefensePrep/DefenseReportDetail.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/setting",
    name: "StudentCenSetting",
    component: () => import("../views/StudentCen/Setting.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
  {
    path: "/StudentCen/privacy",
    name: "StudentCenPrivacy",
    component: () => import("../views/StudentCen/Privacy.vue"),
    beforeEnter: (to, from, next) => checkUserCenterAccess(to, from, next, [4]),
  },
];
const router = new VueRouter({
  routes,
});

// 全局路由守卫
// router.beforeEach((to, from, next) => {
//   const token = getToken();
//   console.log(token);

//   // 判断是否进入/chat路由
//   if (to.path === "/chat" || to.path.includes("/user")) {
//     if (!token) {
//       // 没有token，提示并跳转到登录页
//       next({
//         path: "/login",
//       });
//       return;
//     }
//   }

//   next();
// });
// 核心代码：路由切换后滚动到顶部
router.afterEach((to, from) => {
  // 滚动到页面顶部，{ behavior: 'smooth' } 可选，实现平滑滚动
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // 去掉则是瞬间回到顶部
  });
});
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

export default router;
